import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { EventTypes } from '@cashier-integration/model';

import { getLoadingPageUrl } from '@cashier/cashier-common';
import {
  initiateProcessing,
  selectCashierConfiguration,
  selectPaymentMethod,
  setBonusCode,
} from '@cashier/cashier-data-access';
import { RedirectContainers, WindowNames } from '@cashier/cashier-model';
import { eventBus, ProviderWindowService } from '@cashier/cashier-shared';

interface UseFormAction {
  onFormSubmitted: () => void;
}

export const useFormAction = (): UseFormAction => {
  const dispatch = useDispatch();

  const { redirectContainer } = useSelector(selectPaymentMethod);
  const { platform } = useSelector(selectCashierConfiguration);
  const { direction } = useSelector(selectCashierConfiguration);

  useEffect(() => {
    return eventBus.on(EventTypes.ON_PAYMENT_DATA_PRE_PROCESSED, () => {
      dispatch(initiateProcessing());
    });
  }, [dispatch]);

  useEffect(() => {
    return eventBus.on(EventTypes.ON_BONUS_SELECTED, (event) => {
      dispatch(setBonusCode(event.payload || ''));
    });
  }, [dispatch]);

  const onFormSubmitted = useCallback(() => {
    if (RedirectContainers.NEW_TAB === redirectContainer) {
      ProviderWindowService.initialize(
        WindowNames.Window,
        getLoadingPageUrl(platform || '', direction),
      );
    }

    dispatch(initiateProcessing());
  }, [direction, dispatch, platform, redirectContainer]);

  return {
    onFormSubmitted,
  };
};
